export const LookupMethodEnum = Object.freeze({CONTACT_EMAIL: 'CONTACT_EMAIL', DOMAIN: 'DOMAIN'})


// WEBPACK FOOTER //
// ./src/scripts/constants/SalesforceLeadRoutingConstants.js